import { useAuth } from "@/components/contexts/AuthContext";
import { router } from "@/router";
import { requireAuthorizedResponse } from "@/lib/auth-response";
import { useCallback } from "react";

export function useAuthFetch() {
    const { authState, logout } = useAuth();
    const { token } = authState;

    const memoizedAuthFetch = useCallback(
        async (url: string, options?: RequestInit) => {
            const baseUrl = import.meta.env.VITE_API_URL as string;
            const isFormData = options?.body instanceof FormData;
            const fetchOptions = {
                ...options,
                headers: {
                    ...options?.headers,
                    Authorization: `Bearer ${token}`,
                    ...(isFormData ? {} : { "Content-Type": "application/json" }),
                },
            };

            const response = await fetch(`${baseUrl}${url}`, fetchOptions);

            return requireAuthorizedResponse(response, () => {
                logout();
                void router.navigate("/login", { replace: true });
            });
        },
        [token, logout]
    );

    return memoizedAuthFetch;
}
